import Link from '@/api/link'
import loading from '../helpers/loading'

export default {
  namespaced: true,
  state: {
    ...loading.state
  },
  getters: {
    ...loading.getters,
    links: (state, getters, rootState, rootGetters) => (rootGetters['skiliko/session/currentPlatform'] || {}).links || []
  },
  mutations: {
    ...loading.mutations
  },
  actions: {
    remove: ({ commit, rootGetters }, { id }) => {
      commit('changeLoading', { isLoading: true })
      const platform = rootGetters['skiliko/session/currentPlatform'] || {}
      commit('skiliko/session/currentPlatform', { platform: {
        ...platform,
        links: platform.links.filter(link => link.id !== id)
      } }, { root: true })
      return Link.remove({ id })
        .then(_ => commit('changeLoading', { isLoading: false }))
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    },
    save: ({ commit, rootGetters }, { data }) => {
      commit('changeLoading', { isLoading: true })
      return Link.create({ data })
        .then(({ data }) => {
          const platform = rootGetters['skiliko/session/currentPlatform'] || {}
          commit('skiliko/session/currentPlatform', { platform: {
            ...platform,
            links: [...platform.links, data]
          } }, { root: true })
          commit('changeLoading', { isLoading: false })
          return data
        })
        .catch(error => {
          commit('changeLoading', { isLoading: false })
          throw error
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/links/index.js